import React, {forwardRef, useImperativeHandle} from 'react';
import Lottie from 'react-lottie';
import cx from 'classnames';
import {observer} from 'mobx-react';
import {Dialog, Flex, Text} from '@priority-software/priority-style-react';
import recordAnimation from '../../../../../_legacy/Macro/components/MacroFooter/record.json';
import playAnimation from '../../../../../_legacy/Macro/components/MacroFooter/macroPlay.json';
import {returnFocus} from '../../../../../_shared/GWTBridge/invoke/genPage';
import {stopMacroMessage} from '../../../../../_legacy/Macro/actions/macroActions';
import {formsStore} from '../../../../../stores/Form';
import {texts} from '../../../texts';
import styles from './styles.module.scss';

export const MacrosButtons = observer(
    forwardRef((props, ref) => {
        const {
            removeRecordingMacro,
            setIsRecording,
            isRecording,
            setShowMacroButtons,
            showMacroButtons
        } = formsStore;

        const hideFooter = () => {
            setShowMacroButtons(false);
        };

        const showFooter = (isRecord = false) => {
            setIsRecording(isRecord);
            setShowMacroButtons(true);
            returnFocus();
        };

        useImperativeHandle(ref, () => {
            return {
                showFooter,
                hideFooter
            };
        });

        const handleStop = () => {
            if (isRecording) {
                setShowMacroButtons(false);
                setIsRecording(false);
                removeRecordingMacro();
                returnFocus();
            } else {
                stopMacroMessage();
            }
        };

        const lottieOptions = {
            loop: true,
            autoplay: true,
            animationData: isRecording ? recordAnimation : playAnimation,
            rendererSettings: {
                preserveAspectRatio: 'xMidYMid slice'
            }
        };

        const content = (
            <Flex
                componentClasses={cx('dialog-drag-handle', styles.content)}
                justifyContent={'flex-start'}
            >
                <div className={cx(styles.btn)}>
                    <div className={styles.pulseIcon}>
                        <div className={styles.lottieEl}>
                            <Lottie options={lottieOptions} height={42} width={42} />
                        </div>
                    </div>
                    <Text textColor="primary-700" tag="span" skin="paragraph-2">
                        {texts.macro_recording_text}
                    </Text>
                </div>

                <div className={styles.btn}>
                    <span onClick={handleStop} className={styles.stopIcon} />
                    <Text textColor="primary-700" tag="span" skin="paragraph-2">
                        {texts.macro_stop_text}
                    </Text>
                </div>
            </Flex>
        );

        return (
            showMacroButtons && (
                <Dialog
                    isOpen
                    draggable
                    zIndex={10010}
                    componentClasses={styles.container}
                    content={content}
                    mask={false}
                    closable={false}
                />
            )
        );
    })
);
